import React, { useState, useEffect, useRef, act } from "react"
import { Link } from "react-router-dom"
import { MDBDataTable } from "mdbreact"
import { convertDBDate, membershipApplicationStatisticscardData } from "./common"
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"
import AddMembershipApplicationComponent from "./AddMembershipApplicationComponent"
import ViewMembershipApplicationComponent from "./ViewMembershipApplicationComponent"
import { baseUrl, ROUTE_BASE_URL } from "../../api/common"
import axios from "axios"
import { showToast } from "../Shared/ToastMessage"
import { FormCheck } from "react-bootstrap"
import Loader from "../common/Loader"
import Timeline from "../common/apexChart/timeline"
import * as XLSX from "xlsx"
import { saveAs } from "file-saver"
import { Pagination, InputGroup, FormControl } from "react-bootstrap"
import dayjs from "dayjs";
import Tooltip from '../common/toolTip';
import { useUser } from '../AdminUsers/UserContext';

const MembershipApplication = () => {
  const { checkPermission } = useUser();
  const [addPopupStatus, setAddPopupStatus] = useState(false)
  const [eventType, setEventType] = useState("")
  const [updateId, setUpdateId] = useState("")
  const [viewPopupStatus, setViewPopupStatus] = useState(false)
  const [viewMemberId, setViewMemberId] = useState("")
  const [viewMemberApplication, setViewMemberApplication] = useState("")
  const [applicationId, setApplicationId] = useState(null)

  const [totalRecords, setTotalRecords] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [searchQuery, setSearchQuery] = useState("")

  const [changeStatusFormValues, setChangeStatusFormValues] = useState({
    message: "",
    password: "",
  })

  const [changeStatusErrors, setChangeStatusErrors] = useState({
    message: "",
    password: "",
  })

  const [paymentVerifyErrors, setPaymentVerifyErrors] = useState({
    paymentVerifyId: "",
    paymentVerifyEmail: ""
  })

  const [selectedPaymentId, setSelectedPaymentId] = useState(null)
  const [applicationPaymentAmount, setApplicationPaymentAmount] = useState("")
  const [applicationPaymentDate, setApplicationPaymentDate] = useState("")
  const [applicationPaymentNarration, setApplicationPaymentNarration] = useState("")
  const [applicationStatus, setApplicationStatus] = useState("")
  const [applicationStatusId, setApplicationStatusId] = useState("")
  const [openChangeStatusModal, setOpenChangeStatusModal] = useState(false)
  const [openApproveStatusModal, setOpenApproveStatusModal] = useState(false)

  const [offlinePaymentErrors, setOfflinePaymentErrors] = useState({
    amount: "",
    date: "",
    narration: "",
  })
  const [ascdescData, setAscdescData] = useState(["New", "Old"]);
  const [paymentTypeData, setPaymentTypeData] = useState([])
  const [membershipPackageData, setMembershipPackageData] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  const [applicationMembersData, setApplicationMembersData] = useState([])
  const [memberDashboardData, setMemberDashboardData] = useState(null)
  const [fetchMemberDashboardStatus, setFetchMemberDashboardStatus] = useState(false)
  const [applicationChartData, setApplicationChartData] = useState([])
  const [countryData, setCountryData] = useState([])
  const [stateData, setStateData] = useState([])
  const [postGradData, setPostGradData] = useState([])
  const [superSpecialtyData, setSuperSpecialtyData] = useState([])

  // Filter states
  const [applicationFilterOpen, setApplicationFilterOpen] = useState(false)
  const [statusFilterOpen, setStatusFilterOpen] = useState(false)
  const [ascdescFilterOpen, setAscdescFilterOpen] = useState(false)
  const [selectedApplication, setSelectedApplication] = useState("")
  const [selectedStatus, setSelectedStatus] = useState("")
  const [selectedAscdesc, setSelectedAscdesc] = useState("")
  const [selectedApplicationId, setSelectedApplicationId] = useState("")
  const [selectedStatusId, setSelectedStatusId] = useState("")
  const [selectedPostGrad, setSelectedPostGrad] = useState("")
  const [selectedSuperSpecialty, setSelectedSuperSpecialty] = useState("")
  const [selectedCountryId, setSelectedCountryId] = useState("")
  const [selectedCountry, setSelectedCountry] = useState("")
  const [selectedStateId, setSelectedStateId] = useState("")
  const [selectedState, setSelectedState] = useState("")

  // Search and dropdown states
  const [search, setSearch] = useState("") // Post Graduation search
  const [open, setOpen] = useState(false) // Post Graduation dropdown
  const [postGradHighlightIndex, setPostGradHighlightIndex] = useState(-1)
  const postGradInputRef = useRef(null)
  const postGradItemRefs = useRef([])

  const [superSpecialtySearch, setSuperSpecialtySearch] = useState("") // Super Specialty search
  const [superSpecialtyOpen, setSuperSpecialtyOpen] = useState(false) // Super Specialty dropdown
  const [superSpecialtyHighlightIndex, setSuperSpecialtyHighlightIndex] = useState(-1)
  const superSpecialtyInputRef = useRef(null)
  const superSpecialtyItemRefs = useRef([])

  const [stateSearch, setStateSearch] = useState("") // State search
  const [stateOpen, setStateOpen] = useState(false) // State dropdown
  const [stateHighlightIndex, setStateHighlightIndex] = useState(-1)
  const stateInputRef = useRef(null)
  const stateItemRefs = useRef([])

  const [openApplicationChooseModal, setOpenApplicationChooseModal] = useState(false)
  const [openPaymentVerifyModal, setOpenPaymentVerifyModal] = useState(false)
  const [paymentVerifyId, setPaymentVerifyId] = useState("") 
  const [paymentVerifyEmail, setPaymentVerifyEmail] = useState("") 
  const [applicationChooseOpen, setApplicationChooseOpen] = useState(false)
  const [selectedTableEntry, setSelectedTableEntry] = useState(10)
  const [tableEntriesOpen, setTableEntriesOpen] = useState(false)

  // Filtered data for dropdowns
  const filteredPostGradData = postGradData.filter((item) =>
    item.edu_postgrad_degree.toLowerCase().includes(search.toLowerCase())
  )
  const filteredSuperSpecialtyData = superSpecialtyData.filter((item) =>
    item.edu_superspecialty_degree.toLowerCase().includes(superSpecialtySearch.toLowerCase())
  )
  const filteredStateData = stateData.filter((item) =>
    item.name.toLowerCase().includes(stateSearch.toLowerCase())
  )

  // Handlers
  const handleAddPopup = async(status, type, memberId) => {
    setEventType(type);
    setUpdateId(memberId);
    console.log('memberId received:', memberId);
    if(type==="Add"){
      const hasPermission = await checkPermission("Membership Application", "create");
      if (!hasPermission) return;
    }else{
      const hasPermission = await checkPermission("Membership Application", "update");
      if (!hasPermission) return;
    }
    setAddPopupStatus(status);
  };


  const handleViewMemberPopup = async(status, memberId, application) => {
    setViewMemberApplication(application)
    setViewMemberId(memberId)
    const hasPermission = await checkPermission("Membership Application", "view");
    if (!hasPermission) return;
    setViewPopupStatus(status)
  }

  const handleInputChange = (field, value) => {
    setChangeStatusFormValues({ ...changeStatusFormValues, [field]: value })
  }

  const validate = () => {
    const newErrors = {
      message: "",
      password: "",
    }
    if (!changeStatusFormValues.message.trim()) {
      newErrors.message = "Message cannot be empty"
    }
    // if (!changeStatusFormValues.password.trim()) {
    //   newErrors.password = "Password cannot be empty"
    // }
    setChangeStatusErrors(newErrors)
    return Object.values(newErrors).every((error) => error === "")
  }

  const clearInputValues = () => {
    setChangeStatusErrors({
      message: "",
      password: "",
    })
    setChangeStatusFormValues({
      message: "",
      password: "",
    })
    handleChangeStatusModal()
    handleViewMemberPopup(false, "", "")
  }

const handlePaymentIdChange = (id) => {
  setSelectedPaymentId(id)
  setApplicationPaymentAmount("")
  setApplicationPaymentDate("")
  setApplicationPaymentNarration("")
}

const offlineValidate = () => {
  const newErrors = {
    amount: "",
    date: "",
    narration: "",
  }
  if (!applicationPaymentAmount.trim() || !applicationPaymentDate || !applicationPaymentNarration.trim()) {
    newErrors.amount = !applicationPaymentAmount.trim() ? "Amount cannot be empty" : ""
    newErrors.date = !applicationPaymentDate ? "Date cannot be empty" : ""
    newErrors.narration = !applicationPaymentNarration.trim() ? "Narration cannot be empty" : ""
  }
  setOfflinePaymentErrors(newErrors)
  return Object.values(newErrors).every((error) => error === "")
}

const clearOfflineInputValues = () => {
  setOfflinePaymentErrors({
    amount: "",
    date: "",
    narration: "",
  })
  setSelectedPaymentId(null)
  setApplicationPaymentNarration("")
  setApplicationPaymentDate("")
  setApplicationPaymentAmount("")
  setOpenApproveStatusModal(false)
  handleViewMemberPopup(false, "", "")
}

  const handleApproveStatusModal = () => {
    setOpenApproveStatusModal(false)
    setOfflinePaymentErrors({
      amount: "",
      date: "",
      narration: "",
    })
    setSelectedPaymentId(null)
    setApplicationPaymentNarration("")
    setApplicationPaymentDate("")
    setApplicationPaymentAmount("")
  }

  const handleChangeStatusModal = (status, id, applicationStatus) => {
    setApplicationStatus(applicationStatus)
    setApplicationStatusId(id)
    setOpenChangeStatusModal(status)
  }

  const handleAfterChangeStatus = () => {
    fetchMemberDashboardData()
    fetchMembershipPackageData()
    fetchApplicationMembersData()
    clearInputValues()
  }

  const handleChangeApplicationStatus = async () => {
    if (!validate()) return;

    try {
      const response = await axios.post(
        // `${baseUrl}/api/change_status`,
        `${baseUrl}/api/member_activity_update`,
        {
          ...changeStatusFormValues,
          member_id: viewMemberId,
          application_status: applicationStatusId,
          login_user_id: localStorage.getItem("loginUserId")
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
            },
          })
      if (response.data.status) {
        showToast(response.data.message, "success")
        handleAfterChangeStatus()
      } else {
        showToast(response.data.message, "error")
      }
      } catch (error) {
        console.error("Error changing application status:", error)
      }
  }

  const handleApproveApplicationStatus = async () => {
    if (!selectedPaymentId) {
      showToast("Please choose a payment type", "error")
      return
    }

    if (selectedPaymentId === 2 && !offlineValidate()) {
      return
    }

    try {
      const response = await axios.post(
        `${baseUrl}/api/create_payment_link`,
        {
          ...changeStatusFormValues,
          member_id: viewMemberId,
          application_status: applicationStatusId,
          login_user_id: localStorage.getItem("loginUserId"),
          amount: applicationPaymentAmount,
          payment_method: selectedPaymentId,
          payed_date: applicationPaymentDate,
          narration: applicationPaymentNarration,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        })
      if (response.data.status) {
        showToast(response.data.message, "success")
        handleAfterChangeStatus()
        clearOfflineInputValues()
      } else {
        showToast(response.data.message, "error")
      }
      } catch (error) {
        console.error("Error approving application status:", error)
      }
  }

  const fetchPaymentTypeData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_payment_method`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      })
      if (response.data.status) {
        setPaymentTypeData(response.data.data)
      } else {
        console.error("Error: Failed to fetch payment type data")
      }
      } catch (error) {
        console.error("Error fetching payment type data:", error)
      }
  }

  const fetchMembershipPackageData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_application`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      })
      if (response.data.status) {
        const data = response.data.data.map((item) => ({
          ...item,
          id: item.id,
          title: item.application_name || "N/A",
          slug: `${ROUTE_BASE_URL}/membership-application/${item.slug}` || "N/A",
          count: item.application_count || "N/A",
        }))
        setMembershipPackageData(data)
      } else {
        console.error("Error: Failed to fetch membership package data")
      }
      } catch (error) {
        console.error("Error fetching membership package data:", error)
      }
  }

  const handleRowSelect = (id) => {
    setSelectedRows((prev) => 
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    )
  }

  const getApplicationStatusClass = (type) => {
    switch (type) {
      case 1:
        return "status-all-applications"
      case 2:
        return "status-pending-clarification"
      case 3:
        return "status-pending-actions"
      case 4:
        return "status-pending-resubmission"
      case 6:
        return "status-rejected"
      case 10:
        return "status-payment-status"
      case 12:
        return "status-membership-allotted"
      default:
        return "text-blue"
    }
  }

  const handleSendMail = async (memberId) => {
    try {
      console.log("Sending mail to member ID:", memberId)
      const response = await axios.post(
        `${baseUrl}/api/resend_application_no`,
        {
          id: memberId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        })
      if (response.data.status) {
        showToast(response.data.message, "success")
      } else {
        showToast(response.data.message, "error")
      }
      } catch (error) {
        console.error("Error approving application status:", error)
      }
  }
 const getApplicationPaymentStatusClass = (type) => {
    switch (type) {
      case "Pending":
        return "status-pending-clarification"
      case "Failed":
        return "status-rejected"
     case "Success":
        return "status-membership-allotted"
      default:
        return "text-blue"
    }
  }
  function convertLoginDate(notifyDate) {
    const date = dayjs.utc(notifyDate);
    const now = dayjs();

    if (now.diff(date, "days") > 0) {
      return date.format("DD MMM");
    }
    if (now.diff(date, "hours") > 0) {
      return `${now.diff(date, "hours")} hr`;
    }
    if (now.diff(date, "minutes") > 0) {
      return `${now.diff(date, "minutes")} minutes ago`;
    }
    if (now.diff(date, "seconds") > 0) {
      return `${now.diff(date, "seconds")} seconds ago`;
    }
    return "Just now";
  }
  const membersTableData = {
    columns: [
      {
        label: (
          <FormCheck
            type="checkbox"
            onClickCapture={(e) => e.stopPropagation()}
            onChange={(e) => setSelectedRows(e.target.checked ? applicationMembersData.map((d) => d.id) : [])}
          />
        ),
        field: "select",
        sort: false,
        attributes: {
          style: { width: "2%", textAlign: "center" },
        },
      },
      {
        label: "Member ID",
        field: "memberid",
        // sort: "disabled",
        attributes: {
          style: { width: "8%" },
        },
      },
      {
        label: "Name",
        field: "name",
        width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "12%" },
        },
      },
      {
        label: "Membership Type",
        field: "application_name",
        width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "12%" },
        },
      },
      {
        label: "Application No",
        field: "application_no",
        // sort: "disabled",
        attributes: {
          style: { width: "8%" },
        },
      },
      {
        label: "Payment Status",
        field: "payment_status",
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "8%" },
        },
      },
      {
        label: "Mobile",
        field: "mobile",
        sort: "asc",
        attributes: {
          style: { width: "10%" },
        },
      },
      {
        label: "Email",
        field: "email",
        attributes: {
          style: { width: "10%" },
        },
      },
      {
        label: "Status",
        field: "status",
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "8%" },
        },
      },
      {
        label: "Application Date",
        field: "date",
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "10%" },
        },
      },
      {
        label: "Login Activity",
        field: "login_activity",
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "10%" },
        },
      },
      {
        label: "Actions",
        field: "actions",
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "10%" },
        },
      }
    ],
    rows:
      applicationMembersData &&
      applicationMembersData.map((data, index) => ({
        select: (
          <FormCheck
            type="checkbox"
            checked={selectedRows.includes(data.id)}
            onClickCapture={(e) => e.stopPropagation()}
            onChange={() => handleRowSelect(data.id)}
          />
        ),
        name:data.first_name || data.middle_name || data.last_name
          ? `${data.first_name || ""} ${data.middle_name || ""} ${data.last_name || ""}`
              .trim()
              .replace(/\s+/g, " ")
          : "N/A",
        application_name: data.application_name || "N/A",
        applicationid: data.application_id || "N/A",
        email: data.email || "N/A",
        mobile: data.mobile || "N/A",
        memberid: data.membership_no || "N/A",
        application_no: data.application_no || "N/A",
        status: <span className={getApplicationStatusClass(data.application_status)}>{data.status_name || "N/A"}</span>,
        payment_status: <span className={getApplicationPaymentStatusClass(data.payment_status)}>{data.payment_status || "N/A"}</span>,
        date: convertDBDate(data.member_reg_date) || "N/A",
        login_activity:data.last_login? convertLoginDate(data.last_login):"--",
        actions: (
          <> 
            {/* <Tooltip text="Resend mail for Application No" id={`edit-${data.id}`} /> */}      
            {data.application_no?
              <button
                type="button"
                onClick={(e) =>{e.stopPropagation(); handleSendMail(data.id)}}
                className="btn btn-sm btn-default edit_button_package"
                title="Resend mail for Application No"
                data-for={`edit-${data.id}`}
                data-tip
              >
                  <i className="fa fa-envelope" />
              </button>:"--"
            }
          </> 
        ),
        clickEvent: () => {
          setApplicationId(data.application_id)
          handleViewMemberPopup(true, data.id, data.application_name)
        },
      })),
  }

  const fetchMemberDashboardData = async () => {
    setFetchMemberDashboardStatus(false)
    try {
      const response = await axios.post(
        `${baseUrl}/api/member_dashboard`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      )
      if (response.data.status) {
        setMemberDashboardData(response.data)
        setFetchMemberDashboardStatus(true)
      } else {
        console.error("Error: Failed to fetch member dashboard data")
      }
    } catch (error) {
      console.error("Error fetching member dashboard data:", error)
    }
  }

  const fetchApplicationChartData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/application_chart`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      })
      if (response.data.status) {
        setApplicationChartData(response.data.data)
      } else {
        console.error("Error: Failed to fetch application chart data")
      }
    } catch (error) {
      console.error("Error fetching application chart data:", error)
    }
  }

  const fetchCountryData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_country`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      })
      if (response.data.status) {
        setCountryData(response.data.data)
      } else {
        console.error("Error: Failed to fetch country data")
      }
    } catch (error) {
      console.error("Error fetching country data:", error)
    }
  }

  const fetchStateData = async (searchTerm = "") => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/get_state`,
        {
          id: 101,
          search: searchTerm
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      )
      if (response.data.status) {
        setStateData(response.data.data)
      } else {
        console.error("Error: Failed to fetch state data")
      }
    } catch (error) {
      console.error("Error fetching state data:", error)
    }
  }

  const fetchPostGradData = async (searchTerm = "") => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/get_postgrad_list`,
        {
          search: searchTerm
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      )
      if (response.data.status) {
        setPostGradData(response.data.data)
      } else {
        console.error("Error: Failed to fetch post grad data")
      }
    } catch (error) {
      console.error("Error fetching post grad data:", error)
    }
  }

  const fetchSuperSpecialtyData = async (searchTerm = "") => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/get_superspecialty_list`,
        {
          search: searchTerm
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      )
      if (response.data.status) {
        setSuperSpecialtyData(response.data.data)
      } else {
        console.error("Error: Failed to fetch super specialty data")
      }
    } catch (error) {
      console.error("Error fetching super specialty data:", error)
    }
  }
  const [tableIsLoading, setTableIsLoading] = useState(false); 

  const fetchApplicationMembersData = async (
    id = selectedApplicationId,
    status = selectedStatusId,
    limitValue = rowsPerPage,
    limitoffset = currentPage,
    searchTerm = searchQuery,
    postGraduationDegree = selectedPostGrad,
    eduSuperspecialtyDegree = selectedSuperSpecialty,
    state = selectedStateId,
    ascdesc = selectedAscdesc
  ) => {
    setTableIsLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/get_member`,
        {
          application_id: id,
          application_status: status,
          limit_value: limitValue,
          limit_offset: (limitoffset - 1) * limitValue,
          search: searchTerm,
          edu_postgrad_degree: postGraduationDegree,
          edu_superspecialty_degree: eduSuperspecialtyDegree,
          state: state,
          sort_by_member_no: ascdesc==="Old"?"asc":"desc",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      )
      if (response.data.status) {
        setApplicationMembersData(response.data.data)
        setTotalRecords(response.data.total)
      } else {
        console.error("Error: Failed to fetch application members data")
      }
    } catch (error) {
      console.error("Error fetching application members data:", error)
    } finally {
      setTableIsLoading(false); // Stop loading
    }
  }

  const paymentVerifyValidate = () => {
    const newErrors = {
      paymentVerifiId: "",
      paymentVerifiEmail: ""
    }
    if (!paymentVerifyId.trim()) {
      newErrors.paymentVerifiId = "Payment verify ID cannot be empty"
    }
    if (!paymentVerifyEmail.trim()) {
      newErrors.paymentVerifiEmail = "Email cannot be empty"
    }
    setPaymentVerifyErrors(newErrors)
    return Object.values(newErrors).every((error) => error === "")
  }

  const handlePaymentVerify = async () => {
    if (!paymentVerifyValidate()) return;
    try {
      const response = await axios.post(
        `${baseUrl}/api/verifyPayment`,
        {
          payment_id: paymentVerifyId,
          email: paymentVerifyEmail
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
            },
          })
      if (response.data.status) {
        showToast(response.data.message, "success")
        handleClosePaymentVerifyModal()
      } else {
        showToast(response.data.message, "error")
      }
      } catch (error) {
        console.error("Error changing application status:", error)
      }
  }

  const applicationFilterToggle = () => setApplicationFilterOpen((prevState) => !prevState)
  const statusFilterToggle = () => setStatusFilterOpen((prevState) => !prevState)
  const applicationChooseToggle = () => setApplicationChooseOpen(!applicationChooseOpen)
  const tableEntriesToggle = () => setTableEntriesOpen((prevState) => !prevState)

  const handleApplicationFilter = (application) => {
    setSelectedApplicationId(application.id)
    setSelectedApplication(application.application_name)
  }

  const handleApplicationStatusFilter = (status) => {
    setSelectedStatusId(status.id)
    setSelectedStatus(status.title)
  }

  const handleAscdescFilter = (status) => {
    setSelectedAscdesc(status)
  }

  const handlePostGradFilter = (status) => {
    setSelectedPostGrad(status.edu_postgrad_degree)
  }

  const handleSuperSpecialtyFilter = (status) => {
    setSelectedSuperSpecialty(status.edu_superspecialty_degree)
  }

  const handleCountryFilter = (status) => {
    setSelectedCountry(status.country_name)
    setSelectedCountryId(status.id)
  }

  const handleStateFilter = (status) => {
    setSelectedState(status.name)
    setSelectedStateId(status.id)
  }

  const handlePostGradSearch = async (searchTerm) => {
    setSearch(searchTerm)
  }

  const handleSuperSpecialtySearch = async (searchTerm) => {
    setSuperSpecialtySearch(searchTerm)
  }

  const handleStateSearch = async (searchTerm) => {
    setStateSearch(searchTerm)
  }

  const handleClearFilter = () => {
    setSelectedApplicationId("")
    setSelectedStatusId("")
    setSelectedApplication("")
    setSelectedStatus("")
    setSelectedAscdesc("")
    setSelectedPostGrad("")
    setSelectedSuperSpecialty("")
    setSelectedCountry("")
    setSelectedCountryId("")
    setSelectedState("")
    setSelectedStateId("")
    setSearch("")
    setSuperSpecialtySearch("")
    setStateSearch("")
    setPostGradHighlightIndex(-1)
    setSuperSpecialtyHighlightIndex(-1)
    setStateHighlightIndex(-1)
    setPostGradData([])
    setSuperSpecialtyData([])
    setStateData([])
  }
  
  const [exportToExcelStatus, setExportToExcelStatus] = useState(false);
  const exportToExcel = async() => {
    setExportToExcelStatus(true);
    const hasPermission = await checkPermission("Membership Application", "view");
    if (!hasPermission) return; 
    try { 
    const ws = XLSX.utils.json_to_sheet(
      applicationMembersData
        .filter((action) => selectedRows.includes(action.id))
        .map((data, index) => ({
          "S.No": index + 1,
          Name: `${data.first_name} ${data.last_name}` || "N/A",
          "Father's Name": data.father_name || "N/A",
          DOB: convertDBDate(data.dob),
          Age: data.age || "N/A",
          Nationality: data.nationality || "N/A",
          Gender: data.gender || "N/A",
          "Membership Type": data.application_name || "N/A",
          "Application No": data.application_no || "N/A",
          "Member ID": data.membership_no || "N/A",
          "Mobile Code": data.mobile_code || "N/A",
          Mobile: data.mobile || "N/A",
          Email: data.email || "N/A",
          "Street Address 1": data.street_line1 || "N/A",
          "Street Address 2": data.street_line2 || "N/A",
          City: data.city || "N/A",
          State: data.state_name || "N/A",
          Country: data.country_name || "N/A",
          "Postal/Zip Code": data.pin || "N/A",
          Landline: data.landline || "N/A",
          "STD Code": data.stdcode || "N/A",
          "Education - UG College": data.edu_undergrad_college || "N/A",
          "Education - UG University": data.edu_undergrad_university || "N/A",
          "Education - UG Year": data.edu_undergrad_year || "N/A",
          "Education - PG Degree": data.edu_postgrad_degree || "N/A",
          "Education - PG College": data.edu_postgrad_college || "N/A",
          "Education - PG University": data.edu_postgrad_university || "N/A",
          "Education - PG Year": data.edu_postgrad_year || "N/A",
          "MCI Council Number": data.mci_council_number || "N/A",
          "MCI Council State": data.mci_council_state_name || "N/A",
          "IMR Registration No": data.imr_reg_no || "N/A",
          "ASI Membership No": data.asi_membership_no || "N/A",
          "ASI State": data.asi_state_name || "N/A",
          "Other International Organization": data.other_inter_organisation || "N/A",
          "Other International Organization Value": data.other_inter_organisation_value || "N/A",
          "Application Date": convertDBDate(data.member_reg_date) || "N/A",
          Status: data.status_name || "N/A",
          "Login Activity": "--",
        }))
    )
    const csv = XLSX.utils.sheet_to_csv(ws)
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" })
    saveAs(blob, 'Membership-Application-Report.csv');}
    catch (error) {
      console.error("Error exporting to Excel:", error)
      showToast("Failed to export data. Please try again.", "error")
    }finally {
      setExportToExcelStatus(false);
    }
  }

  const handleApplicationChooseModalOpen = async () => {
    const hasPermission = await checkPermission("Membership Application", "create");
    if (!hasPermission) return; 
    setOpenApplicationChooseModal(true);
  };
  

  const handleApplicationChooseModalClose = () => {
    setOpenApplicationChooseModal(false)
  }

  const handleApplicationChoose = (applicationId) => {
    setApplicationId(applicationId)
    setOpenApplicationChooseModal(false)
    handleAddPopup(true, "Add", "")
  }

  const handleOpenPaymentVerifyModal = async() => {
    const hasPermission = await checkPermission("Verify Payment", "view");
    if (!hasPermission) return; 
    setOpenPaymentVerifyModal(true);
  }

  const handleClosePaymentVerifyModal = () => {
    setOpenPaymentVerifyModal(false);
    setPaymentVerifyId("");
    setPaymentVerifyEmail("");
    setPaymentVerifyErrors(
      {
        paymentVerifyId: "",
        paymentVerifyEmail: ""
      }
    );
  }

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage)
  }

  const handleEntriesChange = (entries) => {
    const newLimit = Number.parseInt(entries, 10)
    setSelectedTableEntry(newLimit)
    setRowsPerPage(newLimit)
    setCurrentPage(1)
  }

  const handleSearch = (event) => {
    setSearchQuery(event.target.value)
    setCurrentPage(1)
  }

  const clearSearch = () => {
    setSearchQuery("")
  }

  // Keyboard navigation handlers
  const handlePostGradKeyDown = (e) => {
    if (!open || filteredPostGradData.length === 0) return
    if (e.key === "ArrowDown") {
      e.preventDefault()
      setPostGradHighlightIndex((prev) =>
        prev < filteredPostGradData.length - 1 ? prev + 1 : 0
      )
    } else if (e.key === "ArrowUp") {
      e.preventDefault()
      setPostGradHighlightIndex((prev) =>
        prev > 0 ? prev - 1 : filteredPostGradData.length - 1
      )
    } else if (e.key === "Enter" && postGradHighlightIndex !== -1) {
      e.preventDefault()
      const selected = filteredPostGradData[postGradHighlightIndex]
      handlePostGradFilter(selected)
      setSearch(selected.edu_postgrad_degree)
      setOpen(false)
    }
  }

  const handleSuperSpecialtyKeyDown = (e) => {
    if (!superSpecialtyOpen || filteredSuperSpecialtyData.length === 0) return
    if (e.key === "ArrowDown") {
      e.preventDefault()
      setSuperSpecialtyHighlightIndex((prev) =>
        prev < filteredSuperSpecialtyData.length - 1 ? prev + 1 : 0
      )
    } else if (e.key === "ArrowUp") {
      e.preventDefault()
      setSuperSpecialtyHighlightIndex((prev) =>
        prev > 0 ? prev - 1 : filteredSuperSpecialtyData.length - 1
      )
    } else if (e.key === "Enter" && superSpecialtyHighlightIndex !== -1) {
      e.preventDefault()
      const selected = filteredSuperSpecialtyData[superSpecialtyHighlightIndex]
      handleSuperSpecialtyFilter(selected)
      setSuperSpecialtySearch(selected.edu_superspecialty_degree)
      setSuperSpecialtyOpen(false)
    }
  }

  const handleStateKeyDown = (e) => {
    if (!stateOpen || filteredStateData.length === 0) return
    if (e.key === "ArrowDown") {
      e.preventDefault()
      setStateHighlightIndex((prev) =>
        prev < filteredStateData.length - 1 ? prev + 1 : 0
      )
    } else if (e.key === "ArrowUp") {
      e.preventDefault()
      setStateHighlightIndex((prev) =>
        prev > 0 ? prev - 1 : filteredStateData.length - 1
      )
    } else if (e.key === "Enter" && stateHighlightIndex !== -1) {
      e.preventDefault()
      const selected = filteredStateData[stateHighlightIndex]
      handleStateFilter(selected)
      setStateSearch(selected.name)
      setStateOpen(false)
    }
  }

  // Fetch data on search input (debounced, only for non-empty search)
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (search.trim() !== "") {
        fetchPostGradData(search)
      } else {
        setPostGradData([]) // Clear data when search is empty
      }
    }, 300)
    return () => clearTimeout(delayDebounce)
  }, [search])

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (superSpecialtySearch.trim() !== "") {
        fetchSuperSpecialtyData(superSpecialtySearch)
      } else {
        setSuperSpecialtyData([]) // Clear data when search is empty
      }
    }, 300)
    return () => clearTimeout(delayDebounce)
  }, [superSpecialtySearch])

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (stateSearch.trim() !== "") {
        fetchStateData(stateSearch)
      } else {
        setStateData([]) // Clear data when search is empty
      }
    }, 300)
    return () => clearTimeout(delayDebounce)
  }, [stateSearch])

  // Scroll to highlighted item
  useEffect(() => {
    if (
      postGradHighlightIndex !== -1 &&
      postGradItemRefs.current[postGradHighlightIndex] &&
      typeof postGradItemRefs.current[postGradHighlightIndex].scrollIntoView === "function"
    ) {
      postGradItemRefs.current[postGradHighlightIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      })
    }
  }, [postGradHighlightIndex])

  useEffect(() => {
    if (
      superSpecialtyHighlightIndex !== -1 &&
      superSpecialtyItemRefs.current[superSpecialtyHighlightIndex] &&
      typeof superSpecialtyItemRefs.current[superSpecialtyHighlightIndex].scrollIntoView === "function"
    ) {
      superSpecialtyItemRefs.current[superSpecialtyHighlightIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      })
    }
  }, [superSpecialtyHighlightIndex])

  useEffect(() => {
    if (
      stateHighlightIndex !== -1 &&
      stateItemRefs.current[stateHighlightIndex] &&
      typeof stateItemRefs.current[stateHighlightIndex].scrollIntoView === "function"
    ) {
      stateItemRefs.current[stateHighlightIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      })
    }
  }, [stateHighlightIndex])

  // Reset highlight indices on input change
  useEffect(() => {
    setPostGradHighlightIndex(-1)
  }, [search])

  useEffect(() => {
    setSuperSpecialtyHighlightIndex(-1)
  }, [superSpecialtySearch])

  useEffect(() => {
    setStateHighlightIndex(-1)
  }, [stateSearch])

  // Initial data fetch
  useEffect(() => {
    fetchMemberDashboardData()
    fetchApplicationChartData()
    fetchPaymentTypeData()
    fetchMembershipPackageData()
  }, [])

  // Fetch application members on filter or pagination change
  useEffect(() => {
    fetchApplicationMembersData(
      selectedApplicationId,
      selectedStatusId,
      rowsPerPage,
      currentPage,
      searchQuery,
      selectedPostGrad,
      selectedSuperSpecialty,
      selectedStateId,
      selectedAscdesc
    )
  }, [
    currentPage,
    rowsPerPage,
    searchQuery,
    selectedApplicationId,
    selectedStatusId,
    selectedPostGrad,
    selectedSuperSpecialty,
    selectedStateId,
    selectedAscdesc
  ])

  return (
    <div className="container-fluid">
      <div className="row clearfix">
        <div className="col-md-12 col-sm-12 three-btn-mt">
          <Link to={`${ROUTE_BASE_URL}/user-member-application-list`} target="_blank" rel="noopener noreferrer">
            <button className="btn btn-info mr-2">
              <i className="fa fa-plus-circle" aria-hidden="true" />{" "}
              <span className="flo-txt-none">New Application</span>
            </button>
          </Link>
          <button onClick={() => handleApplicationChooseModalOpen()} className="btn btn-info mr-2">
            <i className="fa fa-user-plus" aria-hidden="true" /> <span className="flo-txt-none">Add Members</span>
          </button>
          <button onClick={() => handleOpenPaymentVerifyModal()} className="btn btn-info mr-2">
            <i className="fa fa-credit-card" aria-hidden="true" /> <span className="flo-txt-none">Verify Payment</span>
          </button>
        </div>
      </div>
      <div className="block-header">
        <div className="row clearfix">
          <div className="col-md-6 col-sm-12">
            <h1>Membership Application</h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={`${ROUTE_BASE_URL}/`}>AMASI</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Membership Application
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      {memberDashboardData && membershipApplicationStatisticscardData ? (
        <div className="row clearfix justify-content-center">
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 total_member_data_design">
            <div className="card">
              <div className="body first_clr">
                <Link to={`${ROUTE_BASE_URL}/all-membership-application/1`}>
                  <div className="row clearfix">
                    <div className="col-12">
                      <h5 className="mb-0 font_18 cust-height">
                        <span>{membershipApplicationStatisticscardData[0].title}</span>
                      </h5>
                    </div>
                    <div className="col-12 pt-2">
                      <div className="row align_center">
                        <div className="col-md-6">
                          <h2 className="m-b-0 font_18">{`${memberDashboardData.total_count}`.toLocaleString()}</h2>
                        </div>
                        <div className="col-md-6 text-right">
                          <i className="fa fa-file-text-o" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 total_member_data_design">
            <div className="card">
              <div className="body second_clr">
                <Link to={`${ROUTE_BASE_URL}/all-membership-application/3`}>
                  <div className="row clearfix">
                    <div className="col-12">
                      <h5 className="mb-0 font_18 cust-height">
                        <span>{membershipApplicationStatisticscardData[1].title}</span>
                      </h5>
                    </div>
                    <div className="col-12 pt-2">
                      <div className="row align_center">
                        <div className="col-md-6">
                          <h2 className="m-b-0 font_18">{`${memberDashboardData.pending}`.toLocaleString()}</h2>
                        </div>
                        <div className="col-md-6 text-right">
                          <i className="fa fa-clock-o" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 total_member_data_design">
            <div className="card">
              <div className="body third_clr">
                <Link to={`${ROUTE_BASE_URL}/all-membership-application/12`}>
                  <div className="row clearfix">
                    <div className="col-12">
                      <h5 className="mb-0 font_18 cust-height">
                        <span>{membershipApplicationStatisticscardData[2].title}</span>
                      </h5>
                    </div>
                    <div className="col-12 pt-2">
                      <div className="row align_center">
                        <div className="col-md-6">
                          <h2 className="m-b-0 font_18">
                            {`${memberDashboardData.membership_number_allotted}`.toLocaleString()}
                          </h2>
                        </div>
                        <div className="col-md-6 text-right">
                          <i className="fa fa-check-circle" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 total_member_data_design">
            <div className="card">
              <div className="body four_clr">
                <Link to={`${ROUTE_BASE_URL}/all-membership-application/4`}>
                  <div className="row clearfix">
                    <div className="col-12">
                      <h5 className="mb-0 font_18 cust-height">
                        <span>{membershipApplicationStatisticscardData[3].title}</span>
                      </h5>
                    </div>
                    <div className="col-12 pt-2">
                      <div className="row align_center">
                        <div className="col-md-6">
                          <h2 className="m-b-0 font_18">{`${memberDashboardData.resubmit}`.toLocaleString()}</h2>
                        </div>
                        <div className="col-md-6 text-right">
                          <i className="fa fa-exclamation-circle" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 total_member_data_design">
            <div className="card">
              <div className="body five_clr">
                <Link to={`${ROUTE_BASE_URL}/all-membership-application/2`}>
                  <div className="row clearfix">
                    <div className="col-12">
                      <h5 className="mb-0 font_18 cust-height">
                        <span>{membershipApplicationStatisticscardData[4].title}</span>
                      </h5>
                    </div>
                    <div className="col-12 pt-2">
                      <div className="row align_center">
                        <div className="col-md-6">
                          <h2 className="m-b-0 font_18">
                            {`${memberDashboardData.need_clarification}`.toLocaleString()}
                          </h2>
                        </div>
                        <div className="col-md-6 text-right">
                          <i className="fa fa-lightbulb-o" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 total_member_data_design">
            <div className="card">
              <div className="body six_clr">
                <Link to={`${ROUTE_BASE_URL}/all-membership-application/10`}>
                  <div className="row clearfix">
                    <div className="col-12">
                      <h5 className="mb-0 font_18 cust-height">
                        <span>{membershipApplicationStatisticscardData[5].title}</span>
                      </h5>
                    </div>
                    <div className="col-12 pt-2">
                      <div className="row align_center">
                        <div className="col-md-6">
                          <h2 className="m-b-0 font_18">{`${memberDashboardData.pending_payment}`.toLocaleString()}</h2>
                        </div>
                        <div className="col-md-6 text-right">
                          <i className="fa fa-dollar" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 total_member_data_design">
            <div className="card">
              <div className="body seven_clr">
                <Link to={`${ROUTE_BASE_URL}/all-membership-application/6`}>
                  <div className="row clearfix">
                    <div className="col-12">
                      <h5 className="mb-0 font_18 cust-height">
                        <span>{membershipApplicationStatisticscardData[6].title}</span>
                      </h5>
                    </div>
                    <div className="col-12 pt-2">
                      <div className="row align_center">
                        <div className="col-md-6">
                          <h2 className="m-b-0 font_18">{`${memberDashboardData.reject}`.toLocaleString()}</h2>
                        </div>
                        <div className="col-md-6 text-right">
                          <i className="fa fa-times-circle" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 total_member_data_design">
            <div className="card">
              <div className="body ten_clr">
                <Link to={`${ROUTE_BASE_URL}/all-membership-application/15`}>
                  <div className="row clearfix">
                    <div className="col-12">
                      <h5 className="mb-0 font_18 cust-height">
                        <span>Active Members</span>
                      </h5>
                    </div>
                    <div className="col-12 pt-2">
                      <div className="row align_center">
                        <div className="col-md-6">
                          <h2 className="m-b-0 font_18">
                            {`${memberDashboardData.membership_number_allotted}`.toLocaleString()}
                          </h2>
                        </div>
                        <div className="col-md-6 text-right">
                          <i className="fa fa-user-plus" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 total_member_data_design">
            <div className="card">
              <div className="body nine_clr">
                <Link to={`${ROUTE_BASE_URL}/all-membership-application/7`}>
                  <div className="row clearfix">
                    <div className="col-12">
                      <h5 className="mb-0 font_18 cust-height">
                        <span>Inactive Members</span>
                      </h5>
                    </div>
                    <div className="col-12 pt-2">
                      <div className="row align_center">
                        <div className="col-md-6">
                          <h2 className="m-b-0 font_18">{`${memberDashboardData.deactive}`.toLocaleString()}</h2>
                        </div>
                        <div className="col-md-6 text-right">
                          <i className="fa fa-user-times" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12 total_member_data_design">
            <div className="card">
              <div className="body four_clr">
                <Link to={`${ROUTE_BASE_URL}/all-membership-application/0`}>
                  <div className="row clearfix">
                    <div className="col-12">
                      <h5 className="mb-0 font_18 cust-height">
                        <span>Incomplete Applications</span>
                      </h5>
                    </div>
                    <div className="col-12 pt-2">
                      <div className="row align_center">
                        <div className="col-md-6">
                          <h2 className="m-b-0 font_18">{`${memberDashboardData.incomplete}`.toLocaleString()}</h2>
                        </div>
                        <div className="col-md-6 text-right">
                          <i className="fa fa-user-times" />
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Loader />
      )}
      {applicationChartData.length > 0 && (
        <div className="col-xl-12 col-lg-12 p-0">
          <div className="card">
            <div className="header">
              <h2>Application Overview</h2>
              <p className="mt-1 mb-0">Monthly Application Statistics</p>
            </div>
            <div className="body">
              <div id="apex-timeline-chart">
                <Timeline data={applicationChartData} />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="row clearfix member_data_body">
        {membershipPackageData ? (
          membershipPackageData
            .filter((member) => [1, 2, 3, 4].includes(member.id))
            .map((member, index) => {
              const cardColors = ["card-bg-yellow-100", "card-bg-pink-100", "card-bg-green-100", "card-bg-blue-100"]
              const cardClass = cardColors[index % cardColors.length]
              return (
                <div key={index} className="col-lg-3 col-md-6">
                  <div className={`card ${cardClass}`}>
                    <div className="body">
                      <div className="member_appliction_page_heading">{member.title}</div>
                      <div className="text-center">
                        <h4 className="h4 py-4 mb-0 font-weight-bold text-cyan">{member.count}</h4>
                      </div>
                      <div className="text-center">
                        <div className="ml-auto">
                          <Link to={member.slug}>
                            <button className="btn btn-info">View Members</button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })
        ) : (
          <Loader />
        )}
      </div>

      <div className="row clearfix table_scrool">
        <div className="col-lg-12">
          <div className="card">
            <div className="header">
              <h2>Recent Member</h2>
            </div>
            <div className="body">
              <div className="row clearfix">
                <div className="col-md-12 col-sm-12 recent-member-btns">
                  <button
                    disabled={selectedRows.length < 1|| exportToExcelStatus}
                    onClick={() => exportToExcel()}
                    type="button"
                    className="btn btn-info mb-2 mr-1"
                  >
                    <i className="fa fa-file" aria-hidden="true" /> <span className="flo-txt-none"> {exportToExcelStatus ? 'Exporting...' : 'Export'}  
                      {exportToExcelStatus && <i className="fa fa-spinner fa-spin" aria-hidden="true"/>}
                    </span>
                  </button>
                  <div className="btn-default mb-2 mr-1 reports_page">
                    <Dropdown isOpen={applicationFilterOpen} toggle={applicationFilterToggle}>
                      <DropdownToggle caret className="btn btn-default btn-primary m-0">
                        {selectedApplication || "Filter by Application"}
                      </DropdownToggle>
                      <DropdownMenu container="body" className="custom-dropdown-menu">
                        {membershipPackageData &&
                          membershipPackageData
                            .filter((member) => [1, 2, 3, 4].includes(member.id))
                            .map((action) => (
                              <DropdownItem
                                className={`${selectedApplication === action.application_name && "active"}`}
                                key={action.id}
                                onClick={() => handleApplicationFilter(action)}
                              >
                                {action.application_name}
                              </DropdownItem>
                            ))}
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <div className="btn-default mb-2 mr-1 reports_page">
                    <Dropdown isOpen={statusFilterOpen} toggle={statusFilterToggle}>
                      <DropdownToggle caret className="btn btn-default btn-primary m-0">
                        {selectedStatus || "Filter by Status"}
                      </DropdownToggle>
                      <DropdownMenu container="body" className="custom-dropdown-menu">
                        {membershipApplicationStatisticscardData &&
                          membershipApplicationStatisticscardData
                            .filter((action) => ![13].includes(action.id))
                            .map((action) => (
                              <DropdownItem
                                className={`${selectedStatus === action.title && "active"}`}
                                key={action.id}
                                onClick={() => handleApplicationStatusFilter(action)}
                              >
                                {action.title}
                              </DropdownItem>
                            ))}
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <div className="btn-default mb-2 mr-1 reports_page">
                    <Dropdown isOpen={ascdescFilterOpen} toggle={() => setAscdescFilterOpen(!ascdescFilterOpen)}>
                      <DropdownToggle caret className="btn btn-default btn-primary m-0">
                        {selectedAscdesc || "Filter by New/Old"}
                      </DropdownToggle>
                      <DropdownMenu container="body" className="custom-dropdown-menu">
                        {ascdescData.map((action) => (
                              <DropdownItem
                                className={`${selectedAscdesc === action && "active"}`}
                                key={action.id}
                                onClick={() => handleAscdescFilter(action)}
                              >
                                {action}
                              </DropdownItem>
                            ))}
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <div className="btn-default mb-2 mr-1 reports_page dropdown_select_custom" style={{ position: "relative" }}>
                    <input
                      ref={postGradInputRef}
                      type="text"
                      className="btn btn-default btn-primary m-0 custom-dropdown-menu"
                      placeholder="Filter by Post Graduation"
                      value={search}
                      onChange={(e) => handlePostGradSearch(e.target.value)}
                      onFocus={() => setOpen(true)}
                      onBlur={() => setTimeout(() => setOpen(false), 150)}
                      onKeyDown={handlePostGradKeyDown}
                      style={{ width: "100%", boxSizing: "border-box" }}
                    />
                    {search && (
                      <span
                        onClick={() => {
                          setSearch("")
                          setPostGradHighlightIndex(-1)
                          if (postGradInputRef.current) {
                            postGradInputRef.current.focus()
                          }
                        }}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          fontWeight: "bold",
                          color: "#999",
                          zIndex: 1001,
                        }}
                      >
                        ×
                      </span>
                    )}
                    {open && (
                      <div
                        style={{
                          position: "absolute",
                          zIndex: 1000,
                          width: "100%",
                          maxHeight: "200px",
                          overflowY: "auto",
                          border: "1px solid #ccc",
                          backgroundColor: "white",
                        }}
                      >
                        {filteredPostGradData.length === 0 ? (
                          <div className="dropdown-item" style={{ padding: "8px" }}>
                            {search.trim() === "" ? "Start typing to search" : "No results found"}
                          </div>
                        ) : (
                          filteredPostGradData.map((action, index) => (
                            <div
                              key={action.edu_postgrad_degree}
                              ref={(el) => (postGradItemRefs.current[index] = el)}
                              className="dropdown-item"
                              style={{
                                padding: "8px",
                                cursor: "pointer",
                                backgroundColor: index === postGradHighlightIndex ? "#e6f0ff" : "transparent",
                              }}
                              onMouseDown={() => {
                                handlePostGradFilter(action)
                                setSearch(action.edu_postgrad_degree)
                                setOpen(false)
                              }}
                            >
                              {action.edu_postgrad_degree}
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>
                  <div className="btn-default mb-2 mr-1 reports_page dropdown_select_custom" style={{ position: "relative" }}>
                    <input
                      ref={superSpecialtyInputRef}
                      type="text"
                      className="btn btn-default btn-primary m-0 custom-dropdown-menu"
                      placeholder="Filter by Super Specialty"
                      value={superSpecialtySearch}
                      onChange={(e) => handleSuperSpecialtySearch(e.target.value)}
                      onFocus={() => setSuperSpecialtyOpen(true)}
                      onBlur={() => setTimeout(() => setSuperSpecialtyOpen(false), 150)}
                      onKeyDown={handleSuperSpecialtyKeyDown}
                      style={{ width: "100%", boxSizing: "border-box" }}
                    />
                    {superSpecialtySearch && (
                      <span
                        onClick={() => {
                          setSuperSpecialtySearch("")
                          setSuperSpecialtyHighlightIndex(-1)
                          if (superSpecialtyInputRef.current) {
                            superSpecialtyInputRef.current.focus()
                          }
                        }}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          fontWeight: "bold",
                          color: "#999",
                          zIndex: 1001,
                        }}
                      >
                        ×
                      </span>
                    )}
                    {superSpecialtyOpen && (
                      <div
                        style={{
                          position: "absolute",
                          zIndex: 1000,
                          width: "100%",
                          maxHeight: "200px",
                          overflowY: "auto",
                          border: "1px solid #ccc",
                          backgroundColor: "white",
                        }}
                      >
                        {filteredSuperSpecialtyData.length === 0 ? (
                          <div className="dropdown-item" style={{ padding: "8px" }}>
                            {superSpecialtySearch.trim() === "" ? "Start typing to search" : "No results found"}
                          </div>
                        ) : (
                          filteredSuperSpecialtyData.map((action, index) => (
                            <div
                              key={action.edu_superspecialty_degree}
                              ref={(el) => (superSpecialtyItemRefs.current[index] = el)}
                              className="dropdown-item"
                              style={{
                                padding: "8px",
                                cursor: "pointer",
                                backgroundColor: index === superSpecialtyHighlightIndex ? "#e6f0ff" : "transparent",
                              }}
                              onMouseDown={() => {
                                handleSuperSpecialtyFilter(action)
                                setSuperSpecialtySearch(action.edu_superspecialty_degree)
                                setSuperSpecialtyOpen(false)
                              }}
                            >
                              {action.edu_superspecialty_degree}
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>
                  <div className="btn-default mb-2 mr-1 reports_page dropdown_select_custom" style={{ position: "relative" }}>
                    <input
                      ref={stateInputRef}
                      type="text"
                      className="btn btn-default btn-primary m-0 custom-dropdown-menu"
                      placeholder="Filter by State"
                      value={stateSearch}
                      onChange={(e) => handleStateSearch(e.target.value)}
                      onFocus={() => setStateOpen(true)}
                      onBlur={() => setTimeout(() => setStateOpen(false), 150)}
                      onKeyDown={handleStateKeyDown}
                      style={{ width: "100%", boxSizing: "border-box" }}
                    />
                    {stateSearch && (
                      <span
                        onClick={() => {
                          setStateSearch("")
                          setStateHighlightIndex(-1)
                          if (stateInputRef.current) {
                            stateInputRef.current.focus()
                          }
                        }}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          fontWeight: "bold",
                          color: "#999",
                          zIndex: 1001,
                        }}
                      >
                        ×
                      </span>
                    )}
                    {stateOpen && (
                      <div
                        style={{
                          position: "absolute",
                          zIndex: 1000,
                          width: "100%",
                          maxHeight: "200px",
                          overflowY: "auto",
                          border: "1px solid #ccc",
                          backgroundColor: "white",
                        }}
                      >
                        {filteredStateData.length === 0 ? (
                          <div className="dropdown-item" style={{ padding: "8px" }}>
                            {stateSearch.trim() === "" ? "Start typing to search" : "No results found"}
                          </div>
                        ) : (
                          filteredStateData.map((action, index) => (
                            <div
                              key={action.id}
                              ref={(el) => (stateItemRefs.current[index] = el)}
                              className="dropdown-item"
                              style={{
                                padding: "8px",
                                cursor: "pointer",
                                backgroundColor: index === stateHighlightIndex ? "#e6f0ff" : "transparent",
                              }}
                              onMouseDown={() => {
                                handleStateFilter(action)
                                setStateSearch(action.name)
                                setStateOpen(false)
                              }}
                            >
                              {action.name}
                            </div>
                          ))
                        )}
                      </div>
                    )}
                  </div>
                  <button onClick={() => handleClearFilter()} className="btn btn-danger mb-2 mr-1">
                    <i className="fa fa-trash-o" aria-hidden="true" />{" "}
                    <span className="flo-txt-none">Clear Filter</span>
                  </button>
                </div>
              </div>
              <div className="row search_entries">
                <div className="col-md-12 col-sm-12 search_entries">
                  <div className="entries">
                    <p>Show entries: </p>
                    <div className="btn-default mb-2 ml-1">
                      <Dropdown isOpen={tableEntriesOpen} toggle={tableEntriesToggle}>
                        <DropdownToggle caret className="btn-default m-0">
                          {selectedTableEntry || "Filter by Status"}
                        </DropdownToggle>
                        <DropdownMenu container="body" className="custom-dropdown-menu">
                          {[5, 10, 20, 50].map((option) => (
                            <DropdownItem key={option} onClick={() => handleEntriesChange(option)}>
                              {option}
                            </DropdownItem>
                          ))}
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  </div>
                  <div>
                    <InputGroup className="mb-3" style={{ position: "relative" }}>
                      <FormControl placeholder="Search ..." value={searchQuery} onChange={handleSearch} />
                      {searchQuery && (
                        <span className="clear-icon" onClick={clearSearch}>
                          <i className="fa fa-times-circle" aria-hidden="true" />
                        </span>
                      )}
                    </InputGroup>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                {tableIsLoading ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : (
                <>  
                <MDBDataTable
                  noBottomColumns
                  className="table table-hover js-basic-example dataTable table-custom spacing5 check-box-custom"
                  entries={rowsPerPage}
                  data={membersTableData}
                  sortRows={["title"]}
                  paging={false}
                  searching={false}
                />
                <Pagination className="justify-content-center">
                  <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                    Previous
                  </Pagination.Prev>
                  {(() => {
                    const totalPages = Math.ceil(totalRecords / rowsPerPage)
                    const maxPagesToShow = 5
                    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2))
                    let endPage = startPage + maxPagesToShow - 1
                    if (endPage > totalPages) {
                      endPage = totalPages
                      startPage = Math.max(1, endPage - maxPagesToShow + 1)
                    }
                    return [...Array(endPage - startPage + 1)].map((_, index) => {
                      const pageNumber = startPage + index
                      return (
                        <Pagination.Item
                          key={pageNumber}
                          active={pageNumber === currentPage}
                          onClick={() => handlePageChange(pageNumber)}
                        >
                          {pageNumber}
                        </Pagination.Item>
                      )
                    })
                  })()}
                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === Math.ceil(totalRecords / rowsPerPage)}
                  >
                    Next
                  </Pagination.Next>
                </Pagination></>)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddMembershipApplicationComponent
        page="home"
        memberId={updateId}
        eventType={eventType}
        fetchApplicationMembersData={fetchApplicationMembersData}
        memberApplicationId={applicationId}
        addPopupStatus={addPopupStatus}
        handleAddPopup={handleAddPopup}
      />
      <ViewMembershipApplicationComponent
        handleAfterChangeStatus={handleAfterChangeStatus}
        handleChangeStatusModal={handleChangeStatusModal}
        fetchApplicationMembersData={fetchApplicationMembersData}
        memberId={viewMemberId}
        applicationName={viewMemberApplication}
        viewPopupStatus={viewPopupStatus}
        handleAddPopup={handleAddPopup}
        handleViewMemberPopup={handleViewMemberPopup}
      />
      {openChangeStatusModal && (
        <div className="modal fade d-block show">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Change Status</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => handleChangeStatusModal(false, "", "")}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="d-flex mb-3">
                  <div>
                    <h6 className="mb-0">
                      Would you like to change the application status to "{applicationStatus}"?
                    </h6>
                  </div>
                </div>
                {/* <div className="form-group pos_relative">
                  <label>Enter Your Password</label>
                  <input
                    type="text"
                    className={`form-control ${changeStatusErrors.password ? "red_border" : ""}`}
                    value={changeStatusFormValues.password}
                    onChange={(e) => handleInputChange("password", e.target.value)}
                  />
                  {changeStatusErrors && <p className="text-danger pos_abos">{changeStatusErrors.password}</p>}
                </div> */}
                <div className="form-group pos_relative">
                  <label>Message Here</label>
                  <textarea
                    rows={4}
                    type="text"
                    className={`form-control ${changeStatusErrors.message ? "red_border" : ""}`}
                    value={changeStatusFormValues.message}
                    onChange={(e) => handleInputChange("message", e.target.value)}
                  />
                  {changeStatusErrors && <p className="text-danger pos_abos">{changeStatusErrors.message}</p>}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => handleChangeStatusModal(false, "", "")}
                >
                  Close
                </button>
                <button type="button" className="btn btn-success" onClick={handleChangeApplicationStatus}>
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {openApproveStatusModal && (
        <div className="modal fade d-block show">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Change Status</h5>
                <button type="button" className="close" onClick={() => handleApproveStatusModal()} aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="d-flex mb-3">
                  <div>
                    <h6 className="mb-0">Choose a Payment Type</h6>
                  </div>
                </div>
                <div className="form-group pos_relative">
                  <div className="col-lg-12 col-md-12">
                    <div className="check_grid">
                      {paymentTypeData.map((data) => (
                        <div key={data.id}>
                          <FormCheck
                            type="checkbox"
                            id={`checkbox-${data.id}`}
                            label={data.payment_name}
                            checked={selectedPaymentId === data.id}
                            onChange={() => handlePaymentIdChange(data.id)}
                          />
                        </div>
                      ))}
                    </div>
                    {selectedPaymentId === 2 && (
                      <div className="col-lg-12 col-md-12">
                        <div className="row pt-4">
                          <div className="col-lg-4 col-md-4 p-i-0 pos_relative">
                            <input
                              type="number"
                              className={`form-control ${offlinePaymentErrors.amount ? "red_border" : ""}`}
                              placeholder="Amount Paid"
                              value={applicationPaymentAmount}
                              onChange={(e) => setApplicationPaymentAmount(e.target.value)}
                            />
                            {offlinePaymentErrors && (
                              <p className="text-danger pos_abos white_space">{offlinePaymentErrors.amount}</p>
                            )}
                          </div>
                          <div className="col-lg-4 col-md-4 p-i-0 pos_relative">
                            <input
                              type="date"
                              onClick={(e) => e.target.showPicker()}
                              className={`form-control ${offlinePaymentErrors.date ? "red_border" : ""}`}
                              placeholder="Date"
                              value={applicationPaymentDate}
                              onChange={(e) => setApplicationPaymentDate(e.target.value)}
                            />
                          </div>
                          <div className="col-lg-4 col-md-4 p-i-0">
                            <div className="form-group pos_relative">
                              <input
                                type="text"
                                className={`form-control ${offlinePaymentErrors.narration ? "red_border" : ""}`}
                                placeholder="Narration"
                                value={applicationPaymentNarration}
                                onChange={(e) => setApplicationPaymentNarration(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" onClick={() => handleApproveStatusModal()}>
                  Cancel
                </button>
                <button type="button" className="btn btn-danger" onClick={handleApproveApplicationStatus}>
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {openApplicationChooseModal && (
        <div className="modal fade d-block show" style={{ zIndex: 9 }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Member</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => handleApplicationChooseModalClose()}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="d-flex mb-3">
                  <div>
                    <h6 className="mb-0">Choose a Membership Type</h6>
                  </div>
                </div>
                <div className="btn-default mb-2 mr-1">
                  <Dropdown isOpen={applicationChooseOpen} toggle={applicationChooseToggle}>
                    <DropdownToggle caret className="btn-default m-0">
                      {"Membership Type"}
                    </DropdownToggle>
                    <DropdownMenu container="body" className="custom-dropdown-menu">
                      {membershipPackageData && membershipPackageData.length > 0 ? (
                        membershipPackageData
                          .filter((member) => [1, 2, 3, 4].includes(member.id))
                          .map((action) => (
                            <DropdownItem
                              role="button"
                              key={action.id}
                              onClick={() => handleApplicationChoose(action.id)}
                              className={`${selectedApplication === action.application_name ? "active" : ""}`}
                            >
                              {action.application_name}
                            </DropdownItem>
                          ))
                      ) : (
                        <DropdownItem disabled>No Applications Available</DropdownItem>
                      )}
                    </DropdownMenu>
                  </Dropdown>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" onClick={() => handleApplicationChooseModalClose()}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {openPaymentVerifyModal && (
        <div className="modal fade d-block show" style={{ zIndex: 9 }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Payment Verify</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => handleClosePaymentVerifyModal()}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="d-flex mb-3">
                  <div>
                    <h6 className="mb-0">Payment ID</h6>
                  </div>
                </div>
                <div className="btn-default mb-2 mr-1">
                  <div className="form-group pos_relative">
                    <input
                      type="text"
                      className={`form-control ${paymentVerifyErrors.paymentVerifyId ? "red_border" : ""}`}
                      placeholder="Enter your Payment ID"
                      value={paymentVerifyId}
                      onChange={(e) => setPaymentVerifyId(e.target.value)}
                    />
                    {paymentVerifyErrors && (
                      <p className="text-danger pos_abos white_space">{paymentVerifyErrors.paymentVerifyId}</p>
                    )}
                  </div>
                </div>
                <div className="d-flex mb-3">
                  <div>
                    <h6 className="mb-0">Email ID</h6>
                  </div>
                </div>
                <div className="btn-default mb-2 mr-1">
                  <div className="form-group pos_relative">
                    <input
                      type="text"
                      className={`form-control ${paymentVerifyErrors.paymentVerifyEmail ? "red_border" : ""}`}
                      placeholder="Enter your Email ID"
                      value={paymentVerifyEmail}
                      onChange={(e) => setPaymentVerifyEmail(e.target.value)}
                    />
                    {paymentVerifyErrors && (
                      <p className="text-danger pos_abos white_space">{paymentVerifyErrors.paymentVerifyEmail}</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-default" onClick={() => handleClosePaymentVerifyModal()}>
                  Cancel
                </button>
                <button type="button" className="btn btn-info btn-block saveand_proced_button" onClick={() => handlePaymentVerify()}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default MembershipApplication